import { Component, OnInit } from '@angular/core';
import { textos } from './textos';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  idioma = 'pt';
  textos = textos;
  texto = this.textos[0];
  scrollToElement(element: any): void {
    element.scrollIntoView({ behavior: "smooth", inline: "nearest" });
  }

  trocarIdioma(idioma: string): void {
    this.idioma = idioma;
    localStorage.setItem('idioma', idioma);
    if (idioma === 'en') {
      this.texto = this.textos[1];
    }
    else if (idioma === 'fr') {
      this.texto = this.textos[2];
    }
    else if (idioma === 'it') {
      this.texto = this.textos[3];
    }
    else if (idioma === 'es') {
      this.texto = this.textos[4];
    } 
    else {
      this.texto = this.textos[0];
    }
  }

  ngOnInit(): void {
    if (localStorage.getItem('idioma')) {
      this.trocarIdioma(localStorage.getItem('idioma')?.toString() || 'pt');
    }
    $(document).ready((): void => {
     
        $('#Galeria').photoMosaic({
          input: 'html',
          show_loading: true,
          loading_transition: 'fade', // none, fade, scale-up|down, slide-top|right|bottom|left, custom (str)
          responsive_transition: true,
          columns: 4, // 'auto' (str) or (int)
          order: 'random',
          padding: 10,
        });
      
      
      $('#navbarCollapse').singlePageNav({
        speed: 1e3,
        filter: ':not(.external)',
        currentClass: 'active',
        offset: 75
      });

      $('.navbar-nav li a.mod').click((): void => {
        $('.navbar-collapse').collapse('hide');
      });

      $(window).scroll(function () {
        if ($(window).scrollTop() > 40) {
          $('.fixed-top').addClass("topo");
        } else {
          $('.fixed-top').removeClass("topo");
          $('body').css('padding-top', '0');
        }
      });
    });
  }


}